module.exports = __webpack_public_path__ + "img/1.3a8ae4bd.png";